import RouterMiddleware from "src/middleware/RouterMiddleware";
import AuthMiddleware from "src/middleware/AuthMiddleware";
import AlertMiddleware from "src/middleware/AlertMiddleware";
import GuestMiddleware from "src/middleware/GuestMiddleware";
import CheckMiddleware from "./CheckMiddleware";
import SubscriptionMiddleware from "./SubscriptionMiddleware";
import RoleMiddleware from "./RoleMiddleware";

export default new RouterMiddleware({
	RequireAuth: AuthMiddleware,
	CheckMiddleware,
	auth: AuthMiddleware,
	guest: GuestMiddleware,
	alert: AlertMiddleware,
	subscription:SubscriptionMiddleware,
	role: RoleMiddleware
});
